import { m } from "framer-motion";
import { track } from "@/lib/analytics";
import { appDownloadUrl } from "@/lib/appStore";
import WorkspaceLink from "@/components/public/WorkspaceLink";

type ClosingCTAProps = {
  title: string;
  body: string;
  cta: string;
  /** Analytics location tag for the button. */
  location: string;
};

/** The centred closing call to action that ends every marketing page. */
export default function ClosingCTA({ title, body, cta, location }: ClosingCTAProps) {
  return (
    <section className="px-6 pb-[90px] text-center md:px-8">
      <m.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5 }}
        className="mx-auto max-w-3xl"
      >
        <h2 className="text-balance text-3xl font-extrabold tracking-[-0.032em] text-ios md:text-[44px]">
          {title}
        </h2>
        <p className="mt-3 text-base text-ios-secondary md:text-[16.5px]">{body}</p>
        <div className="mt-[26px] flex flex-wrap items-center justify-center gap-4">
        <WorkspaceLink signedOutLabel="Start on the web" className="inline-block rounded-[28px] bg-ios-accent px-[34px] py-[15px] text-base font-semibold text-white shadow-[0_4px_24px_rgba(46,115,184,0.4)]" />
        <m.a
          href={appDownloadUrl()}
          target="_blank"
          rel="noreferrer"
          onClick={() => track("testflight_clicked", { location })}
          whileHover={{ scale: 1.015 }}
          whileTap={{ scale: 0.98 }}
          className="inline-block rounded-[28px] border border-white/15 px-[28px] py-[15px] text-base font-semibold text-ios"
        >
          {cta}
        </m.a>
        </div>
      </m.div>
    </section>
  );
}
